import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const checkboxSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  base: {
    root: defineStyle({
      cursor: 'pointer',
    }),
    control: defineStyle({
      w: 'var(--checkbox-size)',
      h: 'var(--checkbox-size)',
      transitionProperty: 'box-shadow',
      transitionDuration: 'normal',
      border: '2px solid',
      borderRadius: 'sm',
      borderColor: 'inherit',
      color: 'hmGray.400',
      _checked: {
        bg: 'hmGray.500',
        borderColor: 'hmGray.500',
        color: 'white',
        _hover: { bg: 'hmGray.600', borderColor: 'hmGray.600' },
        _disabled: {
          borderColor: 'hmGray.300',
          bg: 'hmGray.300',
          color: 'hmGray.500',
        },
      },
      _indeterminate: {
        bg: 'hmGray.500',
        borderColor: 'hmGray.500',
        color: 'white',
      },
      _disabled: { bg: 'hmGray.200', borderColor: 'hmGray.200' },
      _invalid: { borderColor: 'danger.solid' },
    }),
    label: defineStyle({
      fontWeight: 'normal',
      _disabled: { opacity: 0.4 },
    }),
  },
  variants: {
    variant: {
      reversed: {
        root: defineStyle({
          flexDirection: 'row-reverse',
        }),
      },
    },
  },
});

export default checkboxSlotRecipe;
